import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const TempH2 = styled.h2`
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  ${customTextColor}
`;
